/**
 * @machina/system-dnd5e — D&D 5th Edition game system for Machina VTT
 *
 * Reference implementation of the GameSystemAdapter interface.
 * Wraps existing @machina/core 5e data into the pluggable adapter contract.
 */
export { dnd5eAdapter, DND5E_RULES } from './dnd5e-adapter.js';
// Re-export 5e-specific data from core (for backward compat & direct access)
export { 
// Class data
ALL_CLASS_NAMES, CLASS_HIT_DIE, CLASS_SAVE_PROFICIENCIES, CLASS_CASTER_TYPE, SUBCLASS_LEVEL, CLASS_FEATURES, FULL_CASTER_SLOTS, PACT_MAGIC_TABLE, STANDARD_ASI_LEVELS, FIGHTER_ASI_LEVELS, ROGUE_ASI_LEVELS, MULTICLASS_PREREQUISITES, 
// Functions
getLevelForXp, getXpForNextLevel, getAsiLevels, isAsiLevel, getSpellSlots, meetsMulticlassPrereqs, 
// Level-up
applyLevelUp, 
// Character
getModifier, } from '@machina/core';
// Auto-register on import
import { registerSystem } from '@machina/core';
import { dnd5eAdapter } from './dnd5e-adapter.js';
registerSystem(dnd5eAdapter);
//# sourceMappingURL=index.js.map